export default {"src":"/_next/static/media/filter.2d508535.svg","height":18,"width":18};